import { marked } from 'marked';
import * as cheerio from 'cheerio';

export function markdownToHtml(markdown) {
  if (!markdown) return '';

  const rawHtml = marked.parse(markdown);
  const $ = cheerio.load(rawHtml);

  $('h1').addClass('text-2xl font-bold mb-4 mt-6 text-gray-900');
  $('h2').addClass('text-xl font-bold mb-3 mt-6 text-gray-900');
  $('h3').addClass('text-lg font-semibold mb-3 mt-4 text-gray-900');
  $('h4').addClass('text-base font-semibold mb-2 mt-4 text-gray-900');
  $('h5').addClass('text-sm font-semibold mb-2 mt-4 text-gray-900');
  $('h6').addClass('text-sm font-semibold mb-2 mt-4 text-gray-900');

  $('p').addClass('mb-3 leading-relaxed text-gray-800');

  $('a').addClass('text-ugmonk-dark underline decoration-dotted underline-offset-2 hover:text-ugmonk-dark/80 transition-colors break-all');

  $('ul').addClass('my-3 space-y-1.5 ml-5 text-gray-800 list-disc list-outside');
  $('ol').addClass('my-3 space-y-1.5 ml-5 text-gray-800 list-decimal list-outside');
  $('li').addClass('leading-relaxed');

  $('blockquote').addClass('border-l-4 border-ugmonk-yellow/60 pl-4 py-2 my-4 bg-[#fffdf0] rounded-r-lg italic text-gray-600');

  $('pre').addClass('bg-gray-100 rounded-lg p-3 my-4 overflow-x-auto border border-gray-200');
  $('code').not('pre code').addClass('text-sm font-mono text-gray-800 bg-gray-100 border border-gray-200 px-1.5 py-0.5 rounded');
  $('pre code').removeClass('text-sm font-mono text-gray-800 bg-gray-100 border border-gray-200 px-1.5 py-0.5 rounded').addClass('text-sm font-mono text-gray-800');

  $('table').addClass('min-w-full border border-gray-200 rounded-lg overflow-hidden my-4');
  $('th').addClass('px-4 py-2 bg-gray-50 font-semibold text-left border-b border-gray-200 text-gray-900 text-sm');
  $('td').addClass('px-4 py-2 border-b border-gray-200 text-gray-800 text-sm');

  $('img').addClass('max-w-full h-auto rounded-lg shadow-sm my-4 border border-gray-200');
  $('hr').addClass('my-6 border-t border-gray-200');

  const out = $('body').length ? $('body').html() : $.root().html();
  return out || '';
}
